

<template>
  <div class=" mt-3 card recent-activity">
    <div class="card-body">
      <h5 class="card-title">Outside Activity</h5>
      <ul class="res-activity-list" v-if="mobility_activities">
        <li v-for="(activity, index) in mobility_activities">
          <p class="mb-0" v-if="activity.hit == 0">Punch Out from</p>
          <p class="mb-0" v-else>Punch In from</p>
          <p class="res-activity-time d-inline">
            <i class="fas fa-globe"></i>
            {{ activity.location }},
          </p>
          <p class="d-inline"> at</p>
          <p class="res-activity-time">
            <i class="far fa-clock"></i>
            {{formateMe(activity.attendances_time) }}
          </p>
          <p v-if="activity.remarks" class="res-activity-time">
            <i class="far fa-clock"></i>
            Reason: {{activity.remarks}}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import moment from "moment/moment";

  export default {
    props: ['employee_id','attendances_date'],
    data(){
      return {
        mobility_activities: [],
      }
    },
    methods:{
      formateMe :function(minutes){

        if(minutes == '00:00:00') return '..';

        return moment(minutes, "hh:mm").format('LT');
      },
      getData(){
        axios.get(this.$api_url + '/employee/attendance/punchinorout/activity/' + this.employee_id + '/' + this.attendances_date).then(response => {
          this.mobility_activities = response.data;
        })
      },
    },
    created() {
      this.getData();
    }
  }
</script>